import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlanWithLimits } from '../../../shared/models/plans';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cc-plan-brief-header',
  templateUrl: './plan-brief-header.component.html',
  styleUrls: ['./plan-brief-header.component.scss']
})
export class PlanBriefHeaderComponent implements OnInit {
  @Input() public plan: PlanWithLimits;
  @Input() public compact = false;
  @Input() public canSubscribe = true;
  @Input() public buttonKey = 'PLANS.CHOOSE_PLAN';
  @Output() subscribeClicked = new EventEmitter<PlanWithLimits>();

  constructor() {}

  ngOnInit() {}

  getPriceLabel() {
    if (this.plan.isEnterprise) {
      return `PLANS.LETS_TALK`;
    }
    const baseDollars = `$${Math.round(this.plan.flatPriceCents / 100)}`;
    return baseDollars;
  }

  getWebCallValue() {
    if (!this.plan.webcallLimit) {
      return `PLANS.UNLIMITED`;
    }
    return this.plan.webcallLimit;
  }

  isYearlyPlan() {
    return this.plan.interval === 'P1Y';
  }

  public subscribe() {
    if (this.canSubscribe) {
      this.subscribeClicked.emit(this.plan);
    }
  }
}
